import {
  all,
  call,
  takeEvery,
  fork,
  put,
  takeLatest,
} from "redux-saga/effects";
import actions from "./actions";
import {
  fetchWorkouts as fetchWorkoutsAction,
  fetchUsersSuccess,
  fetchWorkoutsSuccess,
  fetchFullWorkoutSuccess,
} from "./actions";
import { getToken, clearToken } from "../../helpers/utility";
import * as requests from "../../helpers/requests";

import { store } from "../store";

import _ from "lodash";

import config from "../../config";

export function* addContact() {
  yield takeEvery(actions.ADD_CONTACT, function*() {});
}
export function* editContact() {
  yield takeEvery(actions.EDIT_CONTACT, function*() {});
}
export function* deleteContact() {
  yield takeEvery(actions.DELETE__CONTACT, function*() {});
}
// export default function* rootSaga() {
//   yield all([fork(addContact), fork(editContact), fork(deleteContact)]);
// }

const fetchUsers = (url) => {
  return requests.get(url);
};

const fetchWorkouts = (url) => {
  return requests.get(url);
};

const fetchSeriesLog = (url) => {
  return requests.get(url);
};

const patchUser = (user) => {
  let url = config.api_url + `/webapi/v1/userlist/${user.id}/`;
  return requests.patch(url, JSON.stringify(user));
};

export function* watchLoadUsers() {
  const url = config.api_url + `/webapi/v1/userlist/`;
  try {
    const response = yield call(fetchUsers, url);
    yield put(fetchUsersSuccess(response));
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
}

export function* watchLoadWorkouts(action) {
  const url = config.api_url + `/webapi/v1/workoutlog/` + action.id + "/";
  try {
    const response = yield call(fetchWorkouts, url);
    yield put(fetchWorkoutsSuccess(response));
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
}

function fondle_response(response) {
  let series_list = response;
  series_list = series_list.sort(function(a, b) {
    if (a.identifier === b.identifier) {
      if (a.set_number < b.set_number) {
        return -1;
      }
      if (a.set_number > b.set_number) {
        return 1;
      }
    } else if (a.identifier < b.identifier) {
      return -1;
    } else {
      return 1;
    }
  });

  let series_identifiers = series_list.map((item) => item.identifier);
  series_identifiers = [...new Set(series_identifiers)].sort();

  series_identifiers.map((identifier) => {
    var set_1_tracker = 0;
    for (var i = 0; i < series_list.length; i++) {
      if (series_list[i].identifier !== identifier) {
        continue;
      }

      let exercises = series_list[i].exercise_logs;
      exercises = exercises.filter((e) => !e.deleted);
      exercises = exercises.sort((a, b) => (a.order > b.order ? 1 : -1));

      //this handles the data fetch for the display of the top grid section in its entirety
      //
      if (series_list[i].set_number === 1) {
        set_1_tracker = i;
        var display = {};

        for (var j = 0; j < exercises.length; j++) {
          if (exercises[j].time_amount != "") {
            var display_value = exercises[j].time_amount;
          } else {
            var display_value = exercises[j].reps;
          }

          display[exercises[j].series_row_id] = [
            {
              reps: display_value,
              pull_amount: exercises[j].pull_amount,
              series_id: series_list[i].uuid,
              name: exercises[j].name,
              exercise_uuid: exercises[j].exercise_uuid,
              series_row_id: exercises[j].series_row_id,
              tracking_type: exercises[j].tracking_type,
              boolean_log: exercises[j].boolean_log,
              time_amount: exercises[j].time_amount,
              coaches_note: exercises[j].coaches_note,
              order: exercises[j].order,
            },
          ];
        }
        series_list[set_1_tracker]["display"] = display;
      } else {
        for (var j = 0; j < exercises.length; j++) {
          if (exercises[j].time_amount != "") {
            var display_value = exercises[j].time_amount;
          } else {
            var display_value = exercises[j].reps;
          }
          try {
            series_list[set_1_tracker].display[exercises[j].series_row_id].push(
              {
                reps: display_value,
                pull_amount: exercises[j].pull_amount,
                series_id: series_list[i].uuid,
                name: exercises[j].name,
                exercise_uuid: exercises[j].exercise_uuid,
                series_row_id: exercises[j].series_row_id,
                tracking_type: exercises[j].tracking_type,
                boolean_log: exercises[j].boolean_log,
                time_amount: exercises[j].time_amount,
                coaches_note: exercises[j].coaches_note,
              }
            );
          } catch (err) {
            console.log(err);
          }
        }
      } //end of top section display
    }
  }); //end of series_identifiers.map

  for (var i = 0; i < series_list.length; i++) {
    if (series_list[i].set_number == 1) {
      series_list[i].display = _.map(series_list[i].display, (value, key) => ({
        uuid: key,
        sets: value,
      }));
    }
  }

  return series_list;
}
export function* watchLoadFullWorkout(params) {
  const url =
    config.api_url + `/webapi/v1/serieslogfull/` + params.workout_uuid + "/";
  try {
    let response = yield call(fetchSeriesLog, url);
    response = fondle_response(response);
    yield put(fetchFullWorkoutSuccess(response));
    // console.log(response);

    return response;
  } catch (e) {
    console.log(e);
    return;
  }
}

export function* saveExercise1(payload) {
  const url = config.api_url + `/webapi/exercise/`;
  let token = getToken().get("token");

  return fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload.exercise),
    //body: "{}" //needs this or bombs on no json obj to be decoded (probably should fix in django)
  }).then((res) => res.json());

  return;
}

export function* changeContact(action) {
  console.log("in change contact", action);
  console.log("before fetch", action.id);
  yield put(fetchWorkoutsAction({ id: action.id }));
  console.log("after fetch workouts", action.id);
  yield put(actions.changeContactSuccess(action.id, action.tracking_type));
  return;
}

export function* updateUser(action) {
  let { users } = store.getState().Athletes;
  let user = action.payload;
  let repsonse = yield call(patchUser, user);
  users = users.filter((u) => u.id !== user.id);
  users.push(user);
  yield put(fetchUsersSuccess(users));
}

export function* FETCH_INVITES() {
  const url = config.api_url + `/webapi/v1/userinvitelist/`;
  try {
    const response = yield call(fetchUsers, url);
    yield put({ type: "FETCH_INVITES_SUCCESS", payload: response });
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
}

export default function* userSagaWatcher() {
  yield all([
    takeLatest(actions.FETCH_USERS, watchLoadUsers),
    takeLatest(actions.FETCH_WORKOUTS, watchLoadWorkouts),
    takeLatest(actions.FETCH_FULL_WORKOUT, watchLoadFullWorkout),
    takeLatest(actions.CHANGE_CONTACT, changeContact),
    takeLatest(actions.UPDATE_USER, updateUser),
    takeLatest("FETCH_INVITES", FETCH_INVITES),
  ]);
}
